import { render } from "./categoryModel.vue?vue&type=template&id=2ef34421&scoped=true"
import script from "./categoryModel.vue?vue&type=script&lang=js"
export * from "./categoryModel.vue?vue&type=script&lang=js"

import "./categoryModel.vue?vue&type=style&index=0&id=2ef34421&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef34421"]])

export default __exports__